module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-7-c97f6e317b1cbf9eb409ff119ef8135a.png";